import React, { useState } from 'react';
import styled from 'styled-components';
import { useLatestAssessmentIndexForUserQuery } from '../../../graphQL';
import { useDrilldownContext } from '../helpers';
import { Styles } from '../styles';
import { AssessmentFlags } from '../Widgets/AssessmentFlags';
import { AssessmentInsightsModal } from '../Widgets/TriageHeader/components/AssessmentInsightsModal';
import { AssessmentIndexWidget } from '../Widgets/AssessmentIndex/AssessmentIndexWidget';
import { LoadingWidget } from '../Widgets/Loading';
import { TriageHeader } from '../Widgets/TriageHeader';

export const BeaconTab = () => {
  const { user } = useDrilldownContext();
  const [insightsOpen, setInsightsOpen] = useState(false);
  const { data, loading, error } = useLatestAssessmentIndexForUserQuery({
    variables: { userId: user.id },
  });

  if (loading) {
    return <LoadingWidget />;
  }

  if (error) {
    return (
      <Styles.widget role="alert">Unable to load the student's assessment index.</Styles.widget>
    );
  }

  if (!data?.latestAssessmentIndexForUser) {
    return <Styles.widget>No assessment index is available for this student.</Styles.widget>;
  }

  const index = data.latestAssessmentIndexForUser;

  return (
    <BeaconLayoutDiv>
      <TriageHeader index={index} onOpenInsights={() => setInsightsOpen(true)} />
      <AssessmentIndexWidget index={index} />
      <AssessmentFlags flags={index.flags} hasComplexNeeds={index.hasComplexNeeds} />
      <AssessmentInsightsModal
        aiSummary={index.aiSummary}
        isOpen={insightsOpen}
        onClose={() => setInsightsOpen(false)}
      />
    </BeaconLayoutDiv>
  );
};

const BeaconLayoutDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
